import { createContext } from 'svelte'
import { CATEGORIES, type Category, type CategoryMeta } from './categories'


export class PageCategory {
  constructor(private readonly readCategory: () => Category) {}

  get category(): Category {
    return this.readCategory()
  }

  get variant(): CategoryMeta['variant'] {
    return this.meta.variant
  }

  get icon(): CategoryMeta['icon'] {
    return this.meta.icon
  }

  private get meta(): CategoryMeta {
    const meta = CATEGORIES[this.category]
    if (!meta) throw new Error(`Unknown page category: ${this.category}`)

    return meta
  }
}

const [getPageCategoryContext, setPageCategoryContext, hasPageCategoryContext] = createContext<PageCategory>()

export function setPageCategory(pageCategory: PageCategory): void {
  setPageCategoryContext(pageCategory)
}

export function getPageCategory(): PageCategory {
  if (!hasPageCategoryContext()) throw new Error('No page category in context. Wrap this component in a PageCategoryProvider.')

  return getPageCategoryContext()
}
